import { render } from 'base/wrapped-render';
import { ifFeature } from '@bamboohr/utils/lib/feature';
import { renderV2 } from 'base/wrapped-render-v2';

import AddNote from './add-note.react';
import './styles.styl';

export default function(data) {
	return new Promise((resolve) => {
		const addNoteDiv = document.createElement('div');

		const renderer = ifFeature(
			'REACT_18_TT_MIGRATION',
			() => renderV2({
				children: <AddNote afterSave={ resolve } { ...data } />,
				attachedElement: addNoteDiv,
			}),
			() => render(<AddNote afterSave={ resolve } { ...data } />, addNoteDiv)
		);

		renderer();
	});
}
